/**
 * PlayerPageMobileFab barrel — mobile player FAB (Notion 8.6, SE-5083).
 * @module features/player-detail/components/organisms/PlayerPageMobileFab
 */
export { default } from "./PlayerPageMobileFabContainer";
export type { PlayerPageMobileFabContainerProps } from "./PlayerPageMobileFabContainer";
